export const priceGetFormattedPercentageDiscount = (
  percentage: number,
): string => `-${Math.abs(percentage)}%`
